<template>
  <div data-luko-tracking="Page-LukonTermination">
    <LukonTerminationModule :data="data" />
  </div>
</template>

<script>
import LukonTerminationModule from '~/modules/LukonTermination'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    return formatMetaDatas(this.metaDatas, this.$route.path)
  },

  components: {
    LukonTerminationModule,
  },

  async asyncData({ $prismic, app, store, error }) {
    try {
      const { data, alternate_languages } = await $prismic.api.getSingle(
        'lukon_termination_page',
        {
          lang: app.i18n.localeProperties.prismicIso,
        }
      )
      store.dispatch('setAlternateLanguages', alternate_languages)

      return {
        data,
        metaDatas: data.body1 || [],
      }
    } catch (e) {
      console.error(e)
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
